import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import GhaPickupStatusAwb from '../../../models/GhaPickupStatusAwb';

import InfoToWs from './InfoToWh';

interface InfoToWhContainerProps {
  poAwb: GhaPickupStatusAwb;
  doNumber: string;
  code: string;
  number: string;
  ver: number;
  setStatePoAwb: (poAwb: GhaPickupStatusAwb) => void;
  receiveError: Function;
  onlyRead?: boolean;
};

interface InfoToWhContainerState {
  infoToWhs: string;
};

class InfoToWhContainer extends Component<InfoToWhContainerProps, InfoToWhContainerState> {

  state = {
    infoToWhs: ''
  };

  componentDidUpdate(prevProps: InfoToWhContainerProps) {

    if (prevProps.poAwb.info_to_wh !== this.props.poAwb.info_to_wh) {

      const infoToWhs: string = !this.props.poAwb.info_to_wh ? '' : this.props.poAwb.info_to_wh;

      this.setState({ infoToWhs });
    }
  }

  handleChange = (event: any ): void => {
 
    const value: string = event.target.value;

    this.setState({ infoToWhs: value });
  }

  handleSetInfoToWh = (): void => {
   
    const data: {'info_to_wh': string } = {'info_to_wh' : this.state.infoToWhs };

    if (data.info_to_wh === undefined) {
      return;
    }

    pickupOrderRemote.savePoAwbInfoToWh(this.props.doNumber, this.props.code, this.props.number, this.props.ver, data).then((resp: ApiResponse<boolean>) => {
    
      const success: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (success) {

        const poAwb: GhaPickupStatusAwb = { ... this.props.poAwb };
        
        poAwb.info_to_wh = this.state.infoToWhs;
        this.props.setStatePoAwb(poAwb);

      } else {
        this.setState({ infoToWhs: this.props.poAwb.info_to_wh });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });  
  }

  render() {

    return (
      <InfoToWs 
        infoToWhs={ this.state.infoToWhs }
        disabled={ !!this.props.onlyRead }
        handleChange={ this.handleChange }
        handleSetInfoToWh={ this.handleSetInfoToWh }
      />
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
}

export default connect(null, mapDispatchToProps)(InfoToWhContainer);